import React from 'react';
import { FileEntity, FileWithSas } from '../types/file';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface FileContextProps {
  setFileCache: (cache: Map<string, FileWithSas>) => void; // Using a file url cache because apollo caching is really bad, onCompleted is not fired when the cache is hit
  fileCache: Map<string, FileWithSas>;
  files: Map<string, FileEntity>;
  setFiles: (files: Map<string, FileEntity>) => void;
  filesLoading: boolean;
}

const defaultContext = {
  setFileCache: () => null,
  fileCache: new Map(),
  files: new Map(),
  setFiles: () => null,
  filesLoading: false,
};

export const FileContext = React.createContext<FileContextProps>(defaultContext);

interface FileState {
  cache: Record<string, any>[];
  items: Record<string, any>[];
  loading: boolean;
}

export const fileSlice = createSlice({
  name: 'file',
  initialState: { items: [], loading: true, cache: [] } as FileState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<FileEntity[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<FileEntity[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCache: (state, action: PayloadAction<FileWithSas[]>) => {
      state.cache = action.payload.map(p => instanceToPlain(p));
    },
  },
});
